import { authMode, loadCognitoConfig } from "../config";
import { createCognitoSession } from "./cognito-session";
import type { AuthSession } from "./session";

// Wählt die passende AuthSession. `import.meta.env.DEV` ist im Produktions-Build
// die Konstante false: Vite entfernt den ganzen if-Zweig samt dem dynamischen
// import() – der lokale Test-Login kann so nie in einem echten Build landen.
export async function createSession(): Promise<AuthSession> {
  if (import.meta.env.DEV && authMode === "local") {
    const { createLocalSession } = await import("./local-session");
    return createLocalSession();
  }
  return createCognitoSession(await loadCognitoConfig());
}
